const graphTypes = {
  property: 'PROPERTY',
  division: 'DIVISION',
};

export default graphTypes;
